import { createReducer } from '@reduxjs/toolkit';
import _get from 'lodash/get';
import viewingToggledUpdated from '../actions/viewingToggledUpdated';
import processingBegan from '../actions/processingBegan';
import processingEnded from '../actions/processingEnded';
import resetAllToggles from '../actions/resetAllToggles';
import { CALC_ENGINE_KEY } from '../utilities/constants';
import { ingestionBegan } from './StructuredAnalysisSlice';
import { clearAllProjectData } from '../actions/clearAllProjectData';

export const initialState = {
  isProcessing: false,
  isViewingToggled: false,
};

const calcEngine = createReducer(initialState, {
  [processingBegan]: (state) => ({ ...state, isProcessing: true }),
  [processingEnded]: (state) => ({ ...state, isProcessing: false }),
  [viewingToggledUpdated]: (state, action) => ({
    ...state,
    isViewingToggled: action.payload.isViewingToggled,
  }),
  [resetAllToggles]: (state) => ({
    ...state,
    isViewingToggled: false,
  }),
  [ingestionBegan]: (state) => ({
    ...state,
    isViewingToggled: false,
  }),
  [clearAllProjectData]: () => initialState,
});

export const getCalcEngineIsProcessing = (state) =>
  _get(state, [CALC_ENGINE_KEY, 'isProcessing'], false);

export const getIsViewingToggled = (state) =>
  _get(state, [CALC_ENGINE_KEY, 'isViewingToggled'], false);

export default calcEngine;
